<template>
    <div
        v-if="customer?.picking_red_flag"
        class="bg-red-100 border border-red-400 text-red-800 rounded"
        :class="compact ? 'mb-4 p-3 text-sm' : 'mb-4 p-4'"
    >
        <div class="font-semibold">
            This customer's last order had issues - Please pick carefully.
        </div>
        <div v-if="reasonLabels.length" class="mt-2">
            <div class="font-medium" :class="compact ? 'text-xs' : 'text-sm'">Reason{{ reasonLabels.length > 1 ? 's' : '' }}:</div>
            <ul class="list-disc list-inside mt-1" :class="compact ? 'text-xs' : 'text-sm'">
                <li v-for="reason in reasonLabels" :key="reason">{{ reason }}</li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        customer: {
            type: Object,
            default: null,
        },
        compact: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        reasonLabels() {
            const labels = this.customer?.picking_red_flag_reason_labels
                ?? this.customer?.picking_red_flag_reasons
                ?? [];

            return Array.isArray(labels) ? labels.filter(Boolean) : [];
        },
    },
};
</script>
